import { atom } from "recoil";

function getInitialFilters() {
	const params = new URLSearchParams(window.location.search);

	return {
		productType: params.get("productType") || "All",
		member: params.get("member") ? parseInt(params.get("member")!) : "",
		fromDate: params.get("fromDate") ? new Date(params.get("fromDate")!) : new Date(new Date().getFullYear(), 0, 1),
		toDate: params.get("toDate") ? new Date(params.get("toDate")!) : new Date(),
	};
}

export const filtersAtom = atom({
	key: "filters",
	default: getInitialFilters(),
});

export const transactionClaimAtom = atom<{
	claimId: string | null;
	transactionId: string | null;
} | null>({
	key: 'transactionClaimAtom',
	default: null,
});

// ── ⭐ NEW: Persists ClaimsTable filters across route navigation ──
export const claimsFilterAtom = atom({
	key: "claimsFilter",
	default: {
		searchText: "",
		statusFilter: "ALL" as string,
		vendorFilter: "ALL" as string,
		fromDate: "",
		toDate: "",
	},
});